import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterLinkActive,
  RouterOutlet,
} from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from './core/services/auth.service';
import { LimitStatusModalComponent } from './shared/components/limit-status-modal/limit-status-modal.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    LimitStatusModalComponent,
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  sidebarOpen = false;
  showLayout = false;

  private readonly publicRoutes = [
    '/login',
    '/register',
    '/confirm-email',
    '/register-password',
    '/two-fa',
  ];

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        const currentUrl = (event as NavigationEnd).urlAfterRedirects;

        // Verifica se é rota pública
        const isPublicRoute = this.publicRoutes.some((route) =>
          currentUrl.startsWith(route),
        );

        if (isPublicRoute) {
          this.showLayout = false;
        } else {
          // Se não é rota pública, só mostra layout se usuário está autenticado e token válido
          const user = this.authService.getAuthenticatedUser();
          this.showLayout = !!(
            user &&
            user.token &&
            this.authService.isTokenValid(user.token) &&
            user.role === 'CLIENT_CRYPTO'
          );
        }

        this.sidebarOpen = false;
      });
  }

  toggleSidebar(): void {
    this.sidebarOpen = !this.sidebarOpen;
  }

  closeSidebar(): void {
    this.sidebarOpen = false;
  }

  logout(): void {
    this.authService.removeAuthenticatedUser();

    this.sidebarOpen = false;

    this.router.navigate(['/login']);
  }
}